import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import sanitizeHtml from "../utils/sanitizeHtml";

export default function BlogPost() {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  useEffect(() => { axios.get("https://bbest.dev:7500/articles/" + id).then((res) => setPost(res.data)); }, [id]);
  if (!post) return <main className="blog-post"><p>Loading post…</p></main>;
  return <main className="blog-post"><Link to="/blog">← Back to journal</Link><small>{new Date(post.updatedAt || post.createdAt).toLocaleDateString()}</small><h1>{post.title}</h1>{post.image && <img src={post.image} alt="" />}{post.excerpt && <p className="blog-lead">{post.excerpt}</p>}<div className="blog-content" dangerouslySetInnerHTML={{ __html: sanitizeHtml(post.content) }} /></main>;
}
